"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleLineText = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SingleLineText = function SingleLineText() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M12.333 20H23a1 1 0 011 1v1a1 1 0 01-1 1H9l3.333-3z",
    opacity: "0.65"
  }), react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M14.947 1.65c-1.493-1.073-3.616-.788-4.742.637l-.764.967a.392.392 0 00.084.566l7.436 5.348a.437.437 0 00.593-.08l.764-.968c1.125-1.425.827-3.45-.667-4.525l-2.704-1.944zM16.026 11.023a.392.392 0 00-.084-.565L8.506 5.11a.437.437 0 00-.593.08L.186 14.974a.801.801 0 00-.186.484v6.732c-.001.538.54.927 1.082.778l6.776-1.87a.849.849 0 00.441-.29l7.727-9.785z"
  }));
};

exports.SingleLineText = SingleLineText;